import React from 'react';
import { Hero } from '../components/Hero';
import { BrandStatement } from '../components/BrandStatement';
import { Gallery } from '../components/Gallery';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-344" />
      <BrandStatement data-id="element-345" />
      <Gallery data-id="element-346" />
      <Testimonials data-id="element-347" />
      <FinalCTA data-id="element-348" />
    </>;
}